<template>
  <div class="home _width">
    <!-- header_fxed -->
    <Header :router_url="router_url"></Header>
    <!-- header_fxed end -->

    <!-- <p>{{this.$store.getters.headimg}}</p> -->
    <!-- <p>{{headimg}}</p> -->

    <!-- conter -->
    <div class="conter_wp _width">
      <!-- banner -->
      <div class="banner_solt _width">
        <!-- <Banner></Banner> -->
        <!-- 活动首页banner -->
        <!-- 
        <div class="banner_cover _width"
             v-if="loading_bool">
          <Loading :loading_bool="loading_bool"></Loading>
        </div> -->
        <!-- -->
        <div class="banner_cover _width" v-if="!num_data.activityUrl">
          <div class="error_img">
            <div class="error_img_conter">
              <img :src="error_login" alt="" />
            </div>
          </div>
        </div>

        <div class="banner_cover _width" v-if="num_data.activityUrl">
          <!-- <img :src="bin_img_src=='' ? num_data.activityUrl |  :bin_img_src "
               alt=""
               class="_width banner_img"> -->

          <!-- <img v-if="bin_img_src=='' && num_data.activityUrl"
               :src="num_data.activityUrl|filterFun_as"
               alt=""
               class="_width banner_img  fade_image_out">
          <img :src="bin_img_src|filterFun_as"
               alt=""
               class="_width banner_img fade_image_out"
               v-if="bin_img_src!=='' && bin_img_src"> -->

          <img
            :src="items.activityUrl | filterFun_as"
            v-for="(items, indexs) in activity_banner"
            :key="indexs"
            alt=""
            class="banner_img fade_image_out"
            :class="active_banner !== indexs ? '' : 'show_banner'"
          />

          <!-- 封面上的图信息 -->
          <!-- 隐藏封面图的信息 -->
          <!-- <div class="cover_desc _width"
               v-if="bin_title == ''">
            <p> {{num_data.title}}</p>
            <span class="banner_time"
                  v-if="num_data.openTime.time && num_data.endTime.time">
              {{num_data.openTime.time | dateFormat('YYYY-MM-DD')}} 至
              {{num_data.endTime.time | dateFormat('YYYY-MM-DD ')}}
            </span>
          </div>

          <div class="cover_desc _width"
               v-else>
            <p> {{bin_title}}</p>
            <span class="banner_time"
                  v-if="openTime_time && endTime_time">
              {{openTime_time | dateFormat('YYYY-MM-DD')}} 至
              {{endTime_time | dateFormat('YYYY-MM-DD ')}}
            </span>

          </div> -->
          <!-- 封面上的图信息 end-->
        </div>

        <!-- banner side -->
        <ul class="banner_solt_son _width">
          <!-- :style="{background: `url(${items.activityUrl})100% 100% / cover no-repeat`}" -->
          <li
            v-for="(items, indexs) in activity_banner"
            :key="indexs"
            @click="imgCover(items, indexs)"
            :class="banner_unm === indexs ? 'active_tips' : ''"
            class="banner_img"
          >
            <img :src="items.activityUrl | filterFun_bs" alt="" />
            <!-- 图文信息 -->
            <div class="tips">
              <div class="conter _width tips_text">
                <p>
                  {{ items.title }}
                </p>
                <p
                  class="banner_time"
                  v-if="num_data.openTime.time && num_data.endTime.time"
                >
                  {{ num_data.openTime.time | dateFormat("YYYY-MM-DD") }} 至
                  {{ num_data.endTime.time | dateFormat("YYYY-MM-DD ") }}
                </p>
              </div>
              <!-- 三角 -->
              <span></span>
            </div>
            <!-- 图文信息 -->
            <div class="mose"></div>
          </li>
        </ul>
        <!-- banner side -->

        <!-- 活动首页banner end-->
      </div>
      <!-- banner end-->

      <!-- 居中 -->
      <div class="wrap">
        <Loading :loading_bool="loading_bool"></Loading>

        <!-- 活动列表 -->
        <ul
          class="_width activity row anmition_show"
          v-if="!loading_bool && activity.length != 0"
        >
          <li
            v-for="(item, index) in activity"
            :key="index"
            class="fl card_body cos5"
          >
            <div class="activity_conter _width">
              <div
                class="cover_conter _width"
                v-if="item.activityUrl.length == 0"
              >
                <div class="error_img">
                  <div class="error_img_conter">
                    <img :src="error_login" alt="" />
                  </div>
                </div>
              </div>
              <router-link
                :to="'/activity_details/' + item.id"
                target="_blank"
                class="cover_conter _width"
                v-if="item.activityUrl.length !== 0"
              >
                <div class="cover _width">
                  <img
                    :src="item.activityUrl | filterFun_bs"
                    class="fade_image_out cover_img"
                    alt=""
                  />
                </div>
              </router-link>

              <div class="activity_bottom _width mt10 mb10">
                <!-- 标题和状态 -->
                <div class="title_and_type _width mt20">
                  <!-- <router-link :to="'/Ucenter/'+item.userId"
                       target="_blank"
                       class="Headimage"> -->

                  <router-link
                    :to="'/activity_details/' + item.id"
                    target="_blank"
                    class="title padding_common"
                    v-if="item.title"
                    >{{ item.title | filterFun_bs }}
                  </router-link>
                  <!-- 到期状态 -->
                  <div class="type">
                    <!-- 未到期 -->
                    <div class="null_time" v-if="item.status == 2">
                      距离截稿还有 <span>{{ item.followNo }}</span
                      >天
                    </div>

                    <!-- 未到期 -->
                    <div class="end_time" v-if="item.status == 3">已结束</div>
                  </div>
                  <!-- 到期状态 -->
                </div>
                <!-- 标题和状态 end-->

                <!-- 大于7天 -->
                <p
                  class="time _width padding_common mt10 mb10"
                  v-if="item.openTime.time && item.endTime.time"
                >
                  {{ item.openTime.time | dateFormat("YYYY-MM-DD") }} 至
                  {{ item.endTime.time | dateFormat("YYYY-MM-DD ") }}
                </p>
              </div>
            </div>
          </li>
        </ul>
        <!-- 暂无数据 -->
        <ul
          class="_width activity row"
          v-if="!loading_bool && activity.length == 0"
        >
          <div class="null_data _width">
            <img src="@/assets/image/common/null_data.png" alt="" />
            <p>暂无活动...</p>
          </div>
        </ul>
        <!-- 暂无数据 -->

        <div class="_width page_data card_body" style="margin-top: 0.5rem">
          <el-pagination
            background
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :page-sizes="[2, 4, 6, 8]"
            :current-page="page.current_page"
            @current-change="handleCurrentChange"
            :page-size="page.PageSize"
            :total="page.total"
          ></el-pagination>
        </div>

        <!-- 测试 -->
      </div>
      <!-- 居中 -->
    </div>
    <!-- conter end -->

    <!-- footer -->
    <Footer></Footer>
    <!-- footer end-->

    <!-- <is_http :router_url='router_url'></is_http> -->
  </div>
</template>

<script>
import Loading from "@/components/loading/loading.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";

import { getRoles } from "@/utils/api/activity.js";
export default {
  name: "home",
  data() {
    return {
      active_banner: 0, //默认的轮播
      num_data: {
        openTime: {},
        endTime: {},
      }, //默认的还是数据
      // 默认封面
      bin_img_src: "",
      bin_title: "", //封面标题
      openTime_time: "0000-00-00:00:00",
      endTime_time: "0000-00-00:00:00",
      banner_unm: 0,
      // banner
      // 活动数据
      activity: [],
      activity_banner: [], //banner
      // 分页
      page: {
        total: 0, //总数
        current_page: 1, //默认第一页
        PageSize: 10, //每页条数
      },
      value: "",
      loading_bool: true, //加载loading

      // defaultImg: 'this.src="' + require('@/assets/image/common/loading.gif') + '"',//未加载
      error_login: require("@/assets/image/common/loading.gif"),
      testShow: false,
    };
  },
  created() {
    this.router_url = this.$route.fullPath; //当前地址url
    // banner
    let params_banner = {
      alias: "rmhd",
      pageNo: this.page.current_page,
      pageSize: 5,
    };
    // list
    let params = {
      alias: "rmhd",
      pageNo: this.page.current_page,
      pageSize: this.page.PageSize,
    };
    this.getdata_banner(params_banner); //banner
    this.getdata(params); //list
  },
  filters: {
    filterFun_as: function (value) {
      return value.replace(".jpg", "_as.jpg"); //最大
    },
    filterFun_bs: function (value) {
      return value.replace(".jpg", "_bs.jpg"); //最小
    },
  },

  methods: {
    //活动banner数据
    getdata_banner(params) {
      getRoles(params).then((res) => {
        this.loading_bool = true;
        let data = res.data;
        this.num_data = data.list[0];
        this.activity_banner = data.list;
        this.loading_bool = false;
      });
    },

    // 列表
    getdata(params) {
      this.loading_bool = true;
      getRoles(params).then((res) => {
        let data = res.data;
        this.loading_bool = false;
        this.activity = data.list;
        this.page.total = data.total; //全部数据
        this.page.current_page = data.pageNo; //默认第一页
        this.page.PageSize = data.pageSize; //每页条数
      });
    },

    // 点击右侧预览
    imgCover(url, index) {
      this.active_banner = index;

      this.banner_unm = index;
      this.bin_img_src = url.activityUrl;
      this.bin_title = url.title;
      this.openTime_time = url.openTime.time;
      this.endTime_time = url.endTime.time;
    },
    // 活动详情
    // details (id) {
    //   // let routeData this.$router.push({ path: '/activity_details/' + id })
    //   let routeData = this.$router.resolve({ path: '/activity_details/' + id });
    //   window.open(routeData.href, '_blank');
    // },
    // 点击分页
    handleCurrentChange(val) {
      let params = {
        alias: "rmhd",
        pageNo: val,
        pageSize: this.page.PageSize,
      };
      this.getdata(params);
      window.scrollTo(0, 505);
    },
  },
  components: {
    Loading,
    Header,
    Footer,
  },
};
</script>
<style scoped>
@import "../../assets/css/activity/activity.css";

.home {
  min-width: 1305px;
}
</style>



// WEBPACK FOOTER //
// src/views/activity/activity_index.vue